import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { changeDeliveryOptionBody } from "../../services/currentInformation/actions";
import { getPickupPoints } from "../../services/delivery/actions";
import { identify } from "../../services/identify/actions";
import DeliveryOptions from "./DeliveryOptions";
import PickupOptions from "./PickupOptions";

const REDIRECT_URL = "https://easy-dish-pimnijhuis.vercel.app/#/orderhistory";

function ChooseDeliveryOptions(props) {
  const [chosenOption, setChosenOption] = useState("");
  const [method, setMethod] = useState("");
  const [postCode, setPostcode] = useState(null);
  const [postCodeCorrect, setPostcodeCorrect] = useState(false);
  const [postCodeMessage, setPostcodeMessage] = useState(null);
  const [deliveryData, setDeliveryData] = useState(null);
  const [pickupPoints, setPickupPoints] = useState(null);
  const [chosenDate, setChosenDate] = useState(null);
  const [checked, setChecked] = useState(null);
  const [open, setOpen] = useState(false);
  const [chosenPickupData, setChosenPickupData] = useState(null);
  const [chosenDeliveryData, setChosenDeliveryData] = useState(null);
  const [chosenPickupDate, setChosenPickupDate] = useState(null);
  const [readyToPlaceOrderDelivery, setReadyToPlaceOrderDelivery] =
    useState(false);
  const [readyToPlaceOrderPickup, setReadyToPlaceOrderPickup] = useState(false);

  let history = useHistory();

  const defaultCoordinates = {
    center: {
      lat: 51.5787037,
      lng: 5.0028545,
    },
    zoom: 10,
  };

  const handleChange = (event) => {
    setMethod(event.target.value);
  };

  useEffect(() => {
    //Initial value
    if (props.pickup) {
      setChosenOption("Ophalen");
    } else if (props.delivery) {
      setChosenOption("Bezorgen");
    }
  }, []);

  useEffect(() => {
    if (chosenOption === "Ophalen") {
      setPickupPoints(null);
      getPickupPoints(setPickupPoints);
    }
  }, [chosenOption]);

  const createBodyPickup = (location_id, pickupInfo, pay_online) => {
    const [pickupName, pickupID, date, time_open, time_close] =
      pickupInfo.split(";");

    let body = {
      pickup_point: pickupID,
      deliveryDate: date,
      pickup: 1,
      open: time_open,
      close: time_close,
      ...(pay_online && { redirect_url: REDIRECT_URL }),
    };

    return [body, pickupName];
  };

  const createBodyDelivery = (location_id, deliveryInfo, pay_online) => {
    const [date, time_from, time_until, delivery_costs] =
      deliveryInfo.chosenDate.split(";");

    let body = {
      location: location_id,
      deliveryDate: date,
      delivery: 1,
      from: time_from,
      until: time_until,
      delivery_costs: delivery_costs,
      postcode: deliveryInfo.postCode,
      number: deliveryInfo.houseNumber,
      street: deliveryInfo.street,
      city: deliveryInfo.city,
      ...(pay_online && { redirect_url: REDIRECT_URL }),
    };

    return body;
  };

  useEffect(() => {
    if (readyToPlaceOrderPickup) {
      const [body, name] = createBodyPickup(
        props.currentLocation.id,
        chosenPickupData,
        props.payOnline
      );
      props.changeDeliveryOptionBody({
        orderBody: body,
        locationName: name,
      });
      history.push("/confirmorder");
    } else if (readyToPlaceOrderDelivery) {
      props.changeDeliveryOptionBody({
        orderBody: createBodyDelivery(
          props.currentLocation.id,
          chosenDeliveryData,
          props.payOnline
        ),
        locationName: props.currentLocation.name,
      });
      history.push("/confirmorder");
    }
  }, [readyToPlaceOrderPickup, readyToPlaceOrderDelivery]);

  const showEligibleOptions = () => {
    if (props.pickup && props.delivery) {
      return (
        <div>
          <FormControlLabel
            value={"Ophalen"}
            control={<Radio color="primary" />}
            label={"Ophalen"}
            onClick={() => setChosenOption("Ophalen")}
            defaultChecked={true}
          />
          <FormControlLabel
            value={"Bezorgen"}
            control={<Radio color="primary" />}
            label={"Bezorgen"}
            onClick={() => setChosenOption("Bezorgen")}
          />
        </div>
      );
    } else if (props.delivery) {
      return (
        <FormControlLabel
          value={"Bezorgen"}
          control={<Radio color="primary" />}
          label={"Bezorgen"}
          onClick={() => setChosenOption("Bezorgen")}
        />
      );
    } else if (props.pickup) {
      return (
        <FormControlLabel
          value={"Ophalen"}
          control={<Radio color="primary" />}
          label={"Ophalen"}
          onClick={() => setChosenOption("Ophalen")}
        />
      );
    } else {
      return <h4>Er zijn op dit moment helaas geen bezorgmogelijkheden</h4>; // TODO: Wat als je hier komt? Redirect?
    }
  };

  const obtainDeliveryInformation = () => {
    if (chosenOption == "Ophalen") {
      return (
        <PickupOptions
          defaultCoordinates={defaultCoordinates}
          pickupPoints={pickupPoints}
          setChosenPickupOption={setChosenPickupData}
          readyToPlaceOrder={setReadyToPlaceOrderPickup}
        />
        // TODO: geef callback mee met bezorggegevens-object terug
        // TODO: geef boolean terug met plaats bestelling true
        // TODO: maak useEffect op deze boolean en roep place_order call aan met bezorgegevens-object en van login call props.pay_online
      );
    } else {
      return (
        <DeliveryOptions
          currentLocation={props.currentLocation}
          setChosenDeliveryOption={setChosenDeliveryData}
          readyToPlaceOrder={setReadyToPlaceOrderDelivery}
        />
      );
    }
  };

  return (
    <div>
      <center>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={chosenOption}
            onChange={(event) => handleChange(event)}
            align="left"
            row
          >
            <div style={{ textAlign: "center" }}>
              {showEligibleOptions()}

              {obtainDeliveryInformation()}
            </div>
          </RadioGroup>
        </FormControl>
        <Divider />
      </center>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    delivery: state.login.data.delivery,
    pickup: state.login.data.pickup,
    currentLocation: state.login.data.current_location,
    payOnline: state.login.data.pay_online,
  };
}

export default connect(mapStateToProps, { identify, changeDeliveryOptionBody })(
  ChooseDeliveryOptions
);
